import trimEnd from 'lodash/trimEnd'
import trim from 'lodash/trim'

export const filterUrl = (url: string, slash: boolean = true): string => {
  const hasQueryParams = url.includes('?')

  if (hasQueryParams) {
    return trim(url)
  } else {
    const trimmedUrl = trimEnd(url, '/')
    return slash ? trimmedUrl + '/' : trimmedUrl
  }
}
